import { drawerFooterStyle } from '@shared/style/modal';
import { styled } from 'goober';

export const Footer = styled('div')`
    ${drawerFooterStyle}
`;

export const Body = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const FieldsGroup = styled('div')`
    display: flex;
    gap: 20px;
`;

export const InfoGroup = styled('div')`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;
`;
